import { Col, Flex, Form, Input, Row, Select, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import CustomModal from '../CustomModal';
import { getUsers } from '../../redux/actions/users';
import { getFullName } from '../../utils';
import { roleOptions } from '../../constants';

const { Option } = Select;

const UserModal = ({ open, onCancel, onSubmit, data }) => {
    const [form] = Form.useForm();
    const role = Form.useWatch('role', form);
    const [leads, setLeads] = useState([]);

    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                role: data.role,
                status: data.status,
                lead_id: data.lead_id || null,
            });
        } else {
            form.resetFields();
        }
    }, [data, form]);

    useEffect(() => {
        getUsers({ role: 1, isDispatch: false }).then((res) => {
            if (res?.ack) {
                setLeads(res?.users);
            }
        });
    }, []);

    return (
        <CustomModal
            title={data ? 'Update User' : 'Add New User'}
            open={open}
            onCancel={onCancel}
            okText={`${data ? 'Update' : 'Add'} User`}
            onOk={() => form.submit()}
            width={500}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onSubmit}
                initialValues={{
                    role: 2,
                    status: 1,
                }}
                onValuesChange={(changedValues, allValues) => {
                    if (changedValues.role !== undefined && changedValues.role !== 2) {
                        form.setFieldsValue({ lead_id: undefined });
                    }
                }}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="First Name"
                            name="first_name"
                            rules={[{ required: true, message: "Please enter the user's first name!" }]}
                        >
                            <Input placeholder="John" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Last Name" name="last_name">
                            <Input placeholder="Doe" />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                        { required: true, message: 'Please enter email!' },
                        { type: 'email', message: 'Please enter a valid email!' },
                    ]}
                >
                    <Input placeholder="johndoe@example.com" />
                </Form.Item>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Role" name="role">
                            <Select placeholder="Select role" options={roleOptions} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Status" name="status">
                            <Select placeholder="Select role" options={[
                                { value: 1, label: 'Active' },
                                { value: 0, label: 'Inactive' }
                            ]} />
                        </Form.Item>
                    </Col>
                </Row>
                {role === 2 && (
                    <Form.Item
                        label="Lead"
                        name="lead_id"
                    >
                        <Select
                            placeholder="Lead"
                            optionLabelProp="label"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                option.label.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {leads?.map((user) => (
                                <Option key={user?.id} value={user?.id} label={getFullName(user)}>
                                    <Flex vertical gap={1}>
                                        <Typography.Text>{getFullName(user)}</Typography.Text>
                                        <Typography.Text type="secondary">{user.email}</Typography.Text>
                                    </Flex>
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                )}
            </Form>
        </CustomModal>
    );
};

export default UserModal;
